<template>
    <div>
        <img :src="currentSrc" v-show="showImage1" @load="onLoad" />
        <img :src="nextSrc" v-show="!showImage1" @load="onLoad" />
    </div>
</template>
  
<script>
export default {
    props: {
        src: {
        type: String,
        required: true
        }
    },
    data() {
        return {
            currentSrc: this.src,  // Imagen actual mostrada
            nextSrc: '',           // Imagen siguiente a cargar
            showImage1: true       // Controla qué imagen mostrar
        };
    },
    watch: {
        src(newSrc) {
            this.updateImage(newSrc);
        }
    },
    methods: {
        updateImage(newSrc) {
            this.nextSrc = newSrc;
        },
        onLoad() {
            // Alternar entre las imágenes una vez que la nueva imagen se haya cargado
            this.showImage1 = !this.showImage1;
            this.currentSrc = this.nextSrc;
        }
    }
};
</script>

<style scoped>
img {
    width: 100%;
    height: 100%;
    border: none;
    overflow: hidden;
}
</style>
